module.exports = __webpack_public_path__ + "static/media/lostAndFound01.9736eb18.jpg";